import { render, staticRenderFns } from "./TableBuscador.vue?vue&type=template&id=2d6e1194"
import script from "./TableBuscador.vue?vue&type=script&lang=js"
export * from "./TableBuscador.vue?vue&type=script&lang=js"
import style0 from "./TableBuscador.vue?vue&type=style&index=0&id=2d6e1194&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports